import { highmarkFetch } from '../utils/highmark-fetch';

// Note: The base URL from highmarkRestApiUrl already includes '/digital'
// So we only need the path after that
export const BENEFIT_BOOKLET_DOWNLOAD_API =
  '/v1/members/documents/ext/benefit-booklet/file';

/**
 * Downloads a benefit booklet PDF using the provided document key.
 *
 * @param partnerAccessToken - The partner access token for authentication
 * @param documentKey - The encoded document key from the chat message
 * @returns The Response object containing the PDF blob
 */
export const downloadBenefitBooklet = async (
  partnerAccessToken: string,
  documentKey: string,
): Promise<Response> => {
  const payload = {
    documentKey,
  };

  const response = await highmarkFetch(
    BENEFIT_BOOKLET_DOWNLOAD_API,
    partnerAccessToken,
    {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        Accept: 'application/pdf',
      },
    },
  );

  return response;
};
